export default {
  // 微信绑定状态/二维码
  studentWechatBindStatus: '/api/student/wechat/bind-status',
  // 网站小程序登录-场景码组件
  postLoginMpCom: '/api/login-mp-com',
  // 埋点
  postBuryDot: '/api/bury-dot',
  //登录
  login: '/api/login',
  loginV2: '/api/v2/login',
  //发短信前获取数字校验码
  validationDown: '/api/validation/down',
  //上传验证码后发短信
  validationUp: '/api/validation/up',
  validationUpV2: '/api/v2/validation/up',
  getValidationV3: '/api/v3/validation/get',
  studentVerifyCodeSend: '/api/student/verify-code/send',
  studentVerifyCodeCheck: '/api/student/verify-code/check',
  //注册
  register: '/api/register',
  // 提交完善信息
  completeStudentInfo: '/api/student/info',
  getSchoolsByName: '/api/region/schools-by-name',
  // 重置密码
  resetPassword: '/api/reset',
  // 邮箱订阅
  subscribeEmail: '/api/subscribe/email',
  // 记录 学生 表单 状态
  applyStatus: '/api/student/apply/circle-status',
  // 提交 学生 申请表单 Step 1
  studentApply: '/api/student/apply',
  studentApplyStep1: '/api/student/apply/step1',
  // 学生申请表单 Step 2
  studentApplyStep2: '/api/student/apply/step2',
  studentV5ApplyStep2: '/api/student/apply/step2',
  studentSiApply: '/api/student/si/apply',
  // 提交 学生 申请表单 Step 2
  studentApply2: '/api/student/apply-step2',
  // 提交 学生 申请表单 Step 2
  studentApply3: '/api/student/apply-step3',
  // 提交 志愿者 表单 状态
  volStatus: '/api/student/vol/apply/circle-status',
  // 提交 志愿者 表单数据
  volApply: '/api/student/vol/apply',
  // 获取志愿者录取表单
  postVolOfferLetter: '/api/student/volunteer/offer-letter',
  // 阿里云上传签名
  studentOSSCredential: '/api/student/oss/credential',
  // 阿里云上传签名
  slOSSCredential: '/api/sl/oss/credential',
  // 获取申请费订单信息
  getStudentApplyFee: '/api/student/apply/fee',
  // 会场押金下单
  getStudentPlaceDepositFee: '/api/student/place-deposit/fee',
  // 创建支付单
  postStudentPayment: '/api/student/payment',
  // 消费兑换码
  postStudentSDLCodePay: '/api/student/sdl-code/{0}/pay',
  // 轮询支付单支付状态
  postStudentPaymentIsPaid: '/api/student/payment/{0}/is-paid',
  // 用授权code获取 wechat_pay_openid
  postPaymentWechatAuthorize: '/api/payment/wechat/authorize',
  // 验证邮箱
  postValidateEmail: '/api/student/email/validate',
  // 助学金 申请表单
  postBursaryApply: '/api/student/bursary-apply',
  // 学生申请 表单 步骤
  postStuSteps: '/api/student/apply/steps',
  // 学生 费用 订单信息
  getStuTuitionFee: '/api/student/tuition/fee',
  // 提交 学生 费用 状态 数据
  postStuOfferLetter: '/api/student/offer-letter',
  // 获取 主修 Seminar
  postInterestedTracker: '/api/student/survey/interested-tracker',
  //  老师端 单个推荐
  postRecommend: '/api/school/recommendation',
  // 老师端 批量个推荐
  postRecommendMany: '/api/school/import-recommendation',
  // 缴费后 CSI 补申请
  csiStep3buMore: '/api/student/apply-step3-bu-more',
  // 提交sl信息
  postSLProfile: '/api/sl/profile',
  // 提交sl信息
  postCCLProfile: '/api/sl/cl/profile',
  // cs|cl选课
  // 加入购物车
  postStudentCourseCenterCart: '/api/student/course-center/cart',
  // 购物车排序
  postStudentCourseCenterCartSort: '/api/student/course-center/cart/sort',
  // 提交购物车
  postStudentCourseCenterCartSubmit: '/api/student/course-center/cart/submit',
  // Capstone提交购物车
  postStudentCourseCenterCartCpSubmit: '/api/student/course-center/cart/cp-submit',
  // CP课题提交
  postStudentClassCPTask: '/api/student/class/cp/task',
  // 抢课提交
  postStudentCourseCenterGrab: '/api/student/course-center/grab',
  // 抢课退课
  postStudentCourseCenterGrabCancel: '/api/student/course-center/grab-cancel',
  // 选会场
  // 提交会场
  postStudentCourseCenterSurcveyPlace: '/api/student/course-center/survey/place',
  // 游客代付
  // 创建支付单
  postGuestPayment: '/api/guest/payment',
  // 支付轮询
  postGuestPaymentIsPaid: '/api/guest/payment/{0}/is-paid',
  // 抢地盘
  // 移动
  postStudentGameMove: '/api/student/game/move',
  postTeacherGameMove: '/api/teacher/game/move',
  // read 规则已读
  postStudentGameRead: '/api/student/game/read',
  // 答题
  postStudentHouseSorting: '/api/student/house/sorting',
  // 获取生成的海报截屏
  getHouseSortingPoster: '/api/house/sorting_poster',
  // 现场补充信息
  // 基本信息
  postStudentCompleteBasic: '/api/student/complete/basic',
  // 健康信息
  postStudentCompleteHealth: '/api/student/complete/health',
  // 包裹信息
  postStudentCompletePackage: '/api/student/complete/package',
  // academic-writing-workshop
  postStudentSurveyAcademicWritingWorkshopApply: '/api/student/survey/academic-writing-workshop-apply',
  // 已读-作业&评分版本
  postStudentClassCourseIdPeriodAssignmentsGradeVersion: '/api/student/class/course/{0}/{1}/assignments-grade-version',
  // 教师后台
  // 修改Seminar信息
  postTeacherCourse: '/api/teacher/course',
  // 创建作业
  postTeacherAssignment: '/api/teacher/assignment',
  // 同步作业至其它 Seminar
  postTeacherAssignmentApplyDuplicate: '/api/teacher/assignment/apply-duplicate',
  // 阿里云上传签名
  teacherOSSCredential: '/api/teacher/oss/credential',
  // 任何人都可以上传图片
  OSSCredential: '/api/oss/credential',
  // PDF水印
  postTeacherWatermarkCourse: '/api/teacher/watermark/course',
  // 学生端 office Hour 预约和取消
  postStudentClassOfficeHour: '/api/student/class/office-hour/{0}',
  // 学生端增加水印
  postStudentWatermarkCourse: '/api/student/watermark/course',
  // 教师端 签到接口
  postTeacherSign: '/api/teacher/sign',
  // 教师端 Seminar 详情中 office hour 新增接口
  postTeacherHour: '/api/teacher/hour',
  //#region sbp
  // sbp提交
  postStudentSurveySbpApply: '/api/student/survey/sbp-apply',
  // 申请 -- 提交
  postStudentSbpApply: '/api/student/sbp/apply',
  // SBP水印PDF
  postStudentSbpPdfWaterMark: '/api/student/sbp/pdf-water-mark',
  postStudentSbpFee: '/api/student/sbp/fee',
  // 创建支付单
  postStudentSbpPayment: '/api/student/sbp/payment',
  // 轮询支付单支付状态
  postStudentSbpPaymentIsPaid: '/api/student/sbp/payment/{0}/is-paid',
  // 水印PDF
  postStudentSbpPDFWaterMark: '/api/student/sbp/pdf-water-mark',
  //#endregion sbp
  // 学生端交作业
  postStudentClassAssignment: '/api/student/class/assignment/{0}',
  // 管理管 remove move弹窗提交按钮接口
  postAdminRemove: '/api/admin/remove',
  // 管理端-学生管理-提交请假
  postAdminStudentsIdTimeSheets: '/api/admin/students/{0}/time-sheets',
  // 教师端-管理-indexEdit(反馈状态)
  postTeacherHouseStudentsStatesId: '/api/teacher/house/students-states/{0}',
  // 读书会选课
  postStudentCourseCenterFC: '/api/student/course-center/fc/{0}',
  // 读书会取消选课
  postStudentCourseCenterCancel: '/api/student/course-center/fc-cancel/{0}',
  // 疫情通知已读提交
  postStudentOnlineRead: '/api/student/online-read',
  // 新建
  postAdminHouseCup: '/api/admin/house-cup',
  //#region 新生抢课
  postStudentCourseCenterNewSubmit: '/api/student/course-center/new/submit',
  postStudentCourseCenterNewCancel: '/api/student/course-center/new/cancel',
  //#endregion 新生抢课
  //#region cw选课
  // CW提交 ( 正反选合体 )
  postStudentCourseCenterCw: '/api/student/course-center/cw/{0}',
  //#endregion cw选课
  // 提交house-reveal
  postStudentSurveyHouseReveal: '/api/student/survey/house-reveal',
  // 提醒单个学生出席
  postTeacherNotice: '/api/teacher/notice',
  // 提醒全部学生出席
  postTeacherNoticeAll: '/api/teacher/notice-all',
  //#region mission X
  // 学生端提交图片
  postStudentActivityMissionX: '/api/student/activity/mission-x',
  // 教师端 - 新增小队
  postActivityMissionX: '/api/activity/mission-x',
  //#endregion
  //#region Capstone Showcase
  // 喜欢
  postStudentCapstoneShowCaseLike: '/api/student/capstone-show-case/like/{0}',
  postTeacherCapstoneShowCaseLike: '/api/teacher/capstone-show-case/like/{0}',
  //#endregion Capstone Showcase
  // 成绩单列表
  postStudentTranscriptDeliveryOrders: '/api/student/transcript/delivery/orders',
  //#endregion
  //#region 荣誉证书
  postStudentTranscriptCertificateOrders: '/api/student/transcript/certificate/delivery/orders',
  postStudentTranscriptCertificateDeliveryOrderPredictFee: '/api/student/transcript/certificate/delivery/order/predict-fee',
  //#endregion
  //#region 微信交互
  // JSSDK配置
  postWechatJsConfig: '/api/wechat/js-config',
  //#endregion
  //#region 志愿者申请
  // 查询 STEP 1
  postStudentVolApplyStep1: '/api/student/vol/apply/step1',
  // 查询 STEP 2
  postStudentVolApplyStep2: '/api/student/vol/apply/step2',
  //#endregion
  // 获取talent-hunt二维码
  postStudentClubTalentHuntQr: '/api/student/club/talent-hunt-qr',
  //#region Hsylc Club
  postStudentClubTalentHuntPoster: '/api/student/club/talent-hunt-poster',
  //#endregion
  //#region 活动
  // 答案之书 - 提交个人信息
  postActivityAnswerBookInfo: '/api/activity/answer-book/info',
  // 抢课助力——投票
  postActivityCourseVote: '/api/activity/course/vote',
  //#endregion
  //#region  课程中心
  // 提交会场信息
  postStudentCourseSurveyPlace: '/api/student/course-center/survey/place',
  //#endregion
  // 转线上通知已读
  postStudentOfflineToOnline: '/api/student/offline-to-online',
  // 更新头像等激活表相关资料
  postStudentActivate: '/api/student/activate',
  // 提交分院问题 -- 老师端
  postTeacherHouseSorting: '/api/teacher/house/sorting',
  // 虚拟校园入学信息填写
  postStuentVirtualCampusVisa: '/api/student/virtual_campus_visa',
  // WritingCenter提交
  postStudentCourseCenterWriting: '/api/student/course-center/writing',
  // Academic Recourse已读
  postStudentCourseCenterAcademicResource: '/api/student/course-center/academic-recourse',
  //#region IM
  // 提交im信息
  postStudentImInfo: '/api/student/im/info',
  // 获取 IM token
  postStudentImAuth: '/api/student/im/auth',
  // 发起连接
  postStudentImConnect: '/api/student/im/connect',
  // 提前退出
  postStudentImQuit: '/api/student/im/quit',
  // 离开等待页面
  postStudentImLeave: '/api/student/im/leave',
  //#endregion
  postStudentSurveySbpApplyQa2022: '/api/student/survey/sbp-apply-qa-2022',
  // 学生通用表单提交
  postStudentForm: '/api/student/form',
  //#region  消息中心
  postAdminMessages: '/api/admin/messages',
  //#endregion
  //#region hxweek 支付
  // hxweek项目费订单
  postStudentHXWeekFee: '/api/student/hx-week/fee',
  // 订单-席位锁定
  postStudentHXWeekPeriodLock: '/api/student/hx-week/period-lock',
  // 订单-项目尾款
  postStudentHXWeekFeeFinal: '/api/student/hx-week/fee-final',
  // 订单-机票
  postStudentHXWeekFlight: '/api/student/hx-week/flight',
  // 团队机票切换为自行预订
  postStudentHXWeekFlightToOwn: '/api/student/hx-week/flight-2-own',
  // deans list 订单-定金
  postStudentDeansListFee: '/api/student/deans-list/fee',
  // deans list 订单-尾款
  postStudentDeansLisFeeFinal: '/api/student/deans-list/fee-final',
  // deans list 订单-机票
  postStudentDeansLisFight: '/api/student/deans-list/flight',
  //#endregion
  //#region wecom
  postStudentWecomBind: '/api/student/wecom/bind',
  // talent-hunt 绑定推荐关系
  postStudentTalentHuntBind: '/api/student/talent-hunt/bind',
  //#endregion
  //#region 往年成绩单下载
  postSchoolTranscriptBatch: '/api/school/transcript-batch',
  //#endregion
  // 集赞页详情
  postActivityCourseDetail: '/api/activity/course/{0}',
};
